import { render, staticRenderFns } from "./AddFields.vue?vue&type=template&id=df72f5a4&"
import script from "./AddFields.vue?vue&type=script&lang=ts&"
export * from "./AddFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports